import React, {Component} from 'react'
import Loader from "../elements/loader/Loader";
import WidgetHeader from "./WidgetHeader";
import {Row, Col} from "react-bootstrap";

export default class WidgetLoader extends Component {
    render() {
        return (

            <div>
                <Row className="widget-container-padding">
                    <Col md={4} >
                        <div className="widget-form-container loader-form-input-container w-100">
                            <div className="loader-form-input w-25 bg-light" />
                            <div className="loader-form-input w-50 bg-light" />
                            <div className="loader-form-input w-100 bg-light"/>
                            <div className="loader-form-input-transparent w-100"/>
                            <div className="loader-form-input w-100 bg-light"/>
                            <div className="loader-form-input w-50 bg-light"/>
                            <div className="loader-form-input-transparent w-100 "/>
                        </div>
                    </Col>

                    <Col md={8}>
                        <div className="centered-container">
                            <div className="centered">
                                <Loader show />
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Widgets/WidgetLoader.jsx